
import { Box, IconButton, Tooltip, Typography, Button, Dialog, DialogTitle, DialogContent } from "@mui/material"
import MaterialReactTable from "material-react-table"
import React, { useMemo, useRef, useState } from "react"
//Import Material React Table Translations
import { MRT_Localization_ES } from "material-react-table/locales/es"
import { ThemeProvider, darken } from "@mui/material"
import VisibilityIcon from '@mui/icons-material/Visibility';
import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from '@mui/icons-material/Edit';
import ModalAvances from "../modales/ModalAvances"

const VerResultadosButton = ({ row }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const resultadosClaves = {
    indicador: row.original.indicador,
    indicador2: row.original.indicador2,
    indicador3: row.original.indicador3,
    indicador4: row.original.indicador4,
    indicador5: row.original.indicador5,
  };

  return (
    <>
      <Button onClick={handleOpen} variant="contained" size="small">Ver Acciones</Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Acciones Claves:</DialogTitle>
        <DialogContent>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
            {Object.keys(resultadosClaves).map((key, index) => (
              <Typography key={index} variant="body1" style={{ marginBottom: '8px' }}>
                <strong>{`Acción Clave ${index + 1}:`}</strong> {resultadosClaves[key] || ""}
              </Typography>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

const TablaAvancesXobjetivos = ({ columnas, lineas, titulo, handleOpen, handleCancel, acciones, instancia, isLider, idPGD }) => {
  // const [data, setData] = useState(() => lineas)
  const prevLineasRef = useRef(lineas);

  const COLUMNSOBJETIVOS = [
    {
      accessorKey: "id",
    },
    {
      header: "Objetivo",
      accessorKey: "objetivo",
      size: 50,
      minSize: 100,
      maxSize: 200,
      Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
      header: "Fecha de cumplimiento",
      accessorKey: "fechaDeCumplimiento",
      size: 50,
      minSize: 100,
      maxSize: 200,
      Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
      header: "Competencia primaria asociada",
      accessorKey: "competenciaPrimaria",
      size: 50,
      minSize: 100,
      maxSize: 200,
      Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
      header: "Competencia secundaria asociada",
      accessorKey: "competenciaSecundaria",
      size: 50,
      minSize: 100,
      maxSize: 200,
      Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
      header: "Peso %",
      accessorKey: "peso",
      size: 50,
      minSize: 100,
      maxSize: 200,
      Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
      header: "Acciones Claves",
      accessorKey: "indicador",
      size: 50,
      minSize: 150,
      maxSize: 200,
      Cell: ({ row }) => (
        <VerResultadosButton row={row} />
      ),
    },
    {
      header: "% de Avance",
      accessorKey: "porcentajeAvance",
      size: 50,
      minSize: 150,
      maxSize: 200,
      Cell: ({ row }) => (
        <Button onClick={() => handleAbrirModal(row.original.id, (row.original.statusSelect)? row.original.statusSelect.value : null)} variant="contained" size="small">Ver avances</Button>
      ),
    },
    {
      header: "Estado",
      accessorKey: "statusSelect.label",
      size: 50,
      minSize: 100,
      maxSize: 200,
      Cell: ({ row }) => (
        <strong>{row.original.statusSelect?.label}</strong>
      ),
    },
    {
      header: "Motivo",
      accessorKey: "motivoCancelar.label",
      size: 50,
      minSize: 100,
      maxSize: 200,
      Cell: ({ row }) => (
        <strong>{row.original.motivoCancelar?.label}</strong>
      ),
    },
    {
      header: "Estado Final",
      accessorKey: "estadoFinal.label",
      size: 50,
      minSize: 100,
      maxSize: 200,
      Cell: ({ row }) => (
        <strong>{row.original.estadoFinal?.label}</strong>
      ),
    },
  ]

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })
  const [modalOpen, setModalOpen] = useState(false);
  const [modalId, setModalId] = useState(null);
  const [modalStatus, setModalStatus] = useState(null);

  React.useEffect(() => {
    if (prevLineasRef.current !== lineas) {
      prevLineasRef.current = lineas;
    }
  }, [lineas]);

  const columns = useMemo(() => {
    const showMotivoColumn = lineas.some(linea => linea.motivoCancelar !== undefined && linea.motivoCancelar.value);
    // Aplicar lógica condicional para ocultar columnas
    if (instancia === 100000000) {
      return COLUMNSOBJETIVOS.filter(column => column.accessorKey !== "porcentajeAvance" && 
        column.accessorKey !== "statusSelect.label" && column.accessorKey !== "motivoCancelar.label" 
        && column.accessorKey !== "estadoFinal.label" && column.accessorKey !== "competenciaPrimaria"
        && column.accessorKey !== "competenciaSecundaria");
    }
    if(instancia === 100000001) {
      if(showMotivoColumn) {
        return COLUMNSOBJETIVOS.filter(column => column.accessorKey !== "estadoFinal.label");
      }
      else {
        return COLUMNSOBJETIVOS.filter(column => column.accessorKey !== "motivoCancelar.label" && column.accessorKey !== "estadoFinal.label");
      }
    }
    if(instancia === 100000002 && !showMotivoColumn) {
      return COLUMNSOBJETIVOS.filter(column => column.accessorKey !== "motivoCancelar.label");
    }
    return COLUMNSOBJETIVOS;
  }, [instancia, lineas]);

  const openModal = (row) => {
    const id = row.getValue("id");
    const index = row.index;
    if (id !== null) {
      // Objetivo existente con ID
      handleOpen(id, row.original, index);
    } else {
      // Nuevo objetivo sin ID
      handleOpen(null, row.original, index);
    }
  }
  const openModalCancel = (row) => {
    const id = row.getValue("id");
    const index = row.index;
    if (id !== null) {
      // Cancelar Objetivo existente con ID
      handleCancel(id, row.original, index);
    } else {
      // Cancelar Nuevo objetivo sin ID
      handleCancel(null, row.original, index);
    }
  }


  const handleAbrirModal = (id, status) => {
    setModalOpen(true);
    setModalId(id);
    setModalStatus(status);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setModalId(null);
    setModalStatus(null);
  };

  return instancia && isLider !==null && (
    <>
      <ThemeProvider>
        <MaterialReactTable
          muiTablePaginationProps={{
            rowsPerPageOptions: [5, 10],
          }}
          columns={columns}
          data={lineas}
          muiTablePaperProps={{
            sx: (theme) => ({
              borderRadius: '0.55rem',
              border: darken(theme.palette.background.default, 0.1),
              bgcolor: darken(theme.palette.primary.dark, 0.1),
              // maxWidth: '100vw',
              m: 'auto',
            }),
          }}
          onPaginationChange={setPagination}
          state={{ pagination }}
          enableColumnFilterModes={true}
          enableColumnOrdering={true}
          enableColumnActions={true}
          enableColumnFilters={true}
          enableSorting={true}
          enableColumnResizing
          columnResizeMode="onChange"
          enablePinning
          enableRowActions={acciones}
          enableStickyHeader
          enableFullScreenToggle={true}
          initialState={{ showColumnFilters: false, columnVisibility: { id: false }, density: "compact" }}
          positionToolbarAlertBanner="bottom"
          localization={MRT_Localization_ES}
          defaultColumn={{
            maxSize: 400,
            minSize: 40,
          }}
          muiTableHeadCellProps={{
            sx: (theme) => ({
              fontSize: '0.65rem',
              paddingLeft: '0.4rem',
              paddingRight: '0.3rem'
            }),
          }}
          renderRowActions={({ row, table }) => (
            <>
                <Box sx={{ display: "flex"}}>
                  <Tooltip arrow placement="left" title={<Typography sx={{ fontSize: "0.8rem" }}>Ver Objetivo</Typography>}>
                    <IconButton onClick={() => openModal(row)} >
                      <VisibilityIcon />
                    </IconButton>
                  </Tooltip>
                  { row.original.motivoCancelar && !row.original.motivoCancelar.value  && row.original.id && instancia === 100000001 && isLider && (row.original.statusSelect && row.original.statusSelect.value !== 100000001 ) && (
                  <Tooltip arrow placement="left" title={<Typography sx={{ fontSize: "0.8rem" }}>Cancelar</Typography>}>
                    <IconButton onClick={() => openModalCancel(row)}>
                      <CancelIcon color="error" />
                    </IconButton>
                  </Tooltip>
                   )}
                </Box>
            </>
          )}
          renderTopToolbarCustomActions={() => (
            <>
              <Typography variant="subtitle" p="2px">
                {titulo}
              </Typography>
            </>
          )}
        />
      </ThemeProvider>
      <ModalAvances
        open={modalOpen}
        handleClose={handleCloseModal}
        id={modalId}
        status={modalStatus}
        isLider={isLider}
        idPGD={idPGD}
        instancia = {
          instancia === 100000000
              ? "Definición de Objetivos"
              : instancia === 100000001
                ? "Gestión y Seguimiento"
                : instancia === 100000002
                  ? "Balance y Cierre de Año"
                  : ""
        }
      />
    </>
  )
}

export default React.memo(TablaAvancesXobjetivos)
